import { EditMode } from '../Schema/WacFileEditState';
import { getSxSViewStore } from '../store/SxSStore';
import { lazyResetPreviewPane } from 'owa-sxsdata';
import { mutatorAction } from 'satcheljs';

export const resetSxSViewStoreAction = mutatorAction(
    'resetSxSViewStoreAction',
    async function resetSxSViewStoreAction(actionSource: string) {
        const store = getSxSViewStore();
        store.wacFileEditState = {
            fileUrl: '',
            editAllowed: false,
            mode: EditMode.View,
        };

        store.datapoint.addCustomProperty('EndDatapointFrom', actionSource);
        store.datapoint.end();
        (await lazyResetPreviewPane.import())(store.viewState);
    }
);
